import axios from "axios";
export default function stateQuery(symbol, interval) {
  const baseUrl = "https://node.bitazar.com/market/kline";
  return axios
    .get(`${baseUrl}?market=${symbol}&type=${interval}&limit=1`)
    .catch((error) => {
      console.log(error);
    });
}
